import { create } from 'zustand';

type PopupState = {
    icon?: React.ReactNode;
    isOpen: boolean;
    title?: string;
    content?: React.ReactNode;
    onConfirm?: () => void;
    openPopup: (options: {
        icon: React.ReactNode;
        title: string;
        content: React.ReactNode;
        onConfirm?: () => void;
    }) => void;
    closePopup: () => void;
};

export const usePopupStore = create<PopupState>((set) => ({
    isOpen: false,
    icon: undefined,
    title: undefined,
    content: undefined,
    onConfirm: undefined,
    openPopup: ({ icon, title, content, onConfirm }) =>
        set({ isOpen: true, icon, title, content, onConfirm }),
    closePopup: () =>
        set({ isOpen: false, icon: undefined, title: undefined, content: undefined, onConfirm: undefined }),
}));
